var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGambioGmbhLogoVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "layer",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-153 -46 652 652",
    style: {
      enableBackground: "new -153 -46 652 652"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#002337;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-130.3,321.1h22.5c0.8,12.8,9.6,16.8,20.8,16.8c10.7,0,20.5-5,20.5-15.3c0-8.1-5.2-14.3-20.2-14.3 c-27.2,0-44.8-16.1-44.8-41.8c0-28.1,21.7-42.3,44.8-42.3c5.9,0,35.4,18.8,35.4,18.8c5.5,6.7,8.6,14.4,8.6,22.2 c0,12.6-5.2,24.2-17.8,30.7C-42,304-42,317.9-42,322.6c0,24.7-22.3,36.6-45,36.6C-115.9,359.2-130.8,345.1-130.3,321.1z  M-65.8,266.5c0-11.6-8.9-20.8-20.8-20.8c-12.3,0-21.5,7.4-21.5,20.8c0,12.1,9.2,19.8,21.5,19.8 C-75.7,286.3-65.8,279.8-65.8,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-42.8,266.2c0,23.1-19.9,41.9-44.4,41.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-87.1,224.2c24.5,0,44.4,18.8,44.4,42"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -59.3,
    y: 221.5,
    transform: "matrix(-0.6756 0.7373 -0.7373 -0.6756 82.8177 427.8452)",
    className: "st0",
    width: 13.1,
    height: 21.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-29.9,266.8c0-27,18.5-43.3,42.3-43.3c11.1,0,21,3.9,25.7,11.4l0.8-9.6h22.7v82.9H39.7l-1.3-10.4 c-5.4,9.4-17.4,12.9-25.5,12.9C-11.9,310.7-29.9,294.1-29.9,266.8z M38.1,267.6c0-11.9-7.7-22.8-22-22.8c-12.1,0-21.8,8.2-21.8,22 s9.7,21.8,21.8,21.8C29.7,288.6,38.1,277.8,38.1,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82,225.3h21.1l1.7,9.4c5.4-8.9,14.4-11.2,21.8-11.2c8.9,0,19,3.5,24.3,15.4c7.4-11.4,15.1-15.4,27.3-15.4 c17.3,0,33.1,8.4,33.1,39.4v45.3H187v-44.8c0-10.6-2.7-17.3-12.6-17.3c-9.6,0-14.1,8.2-14.1,17.6v44.5h-23.8v-44.5 c0-10.9-5.4-18.1-15.4-18.1c-9.6,0-14.9,8.9-14.9,18.3v44.3H82V225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.8,297.6l-1.5,10.6h-21.7V190.8H255v44.6c7.2-8.9,16.1-11.9,26-11.9c24.3,0,41.3,16.4,41.3,43.3 c0,25.8-16.6,43.9-40.9,43.9C270.7,310.7,261.3,308.5,253.8,297.6z M297.9,266.8c0-12.6-7.7-21.3-20.3-21.3 c-11.2,0-22.3,7.2-22.3,21.3c0,15.8,11.4,21.3,22.3,21.3C290.5,288.1,297.9,278.7,297.9,266.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.3,203.3c0-9.2,6.9-13.6,13.8-13.6s13.8,4.4,13.8,13.6c0,9.2-6.9,13.6-13.8,13.6 C343.2,216.9,336.3,212.6,336.3,203.3z M338,225.3h24.1v82.9H338L338,225.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.8,266.9c0-25,17.8-43.4,45.3-43.4c27.7,0,45.5,18.5,45.5,43.4c0,26.5-17.3,43.9-45.5,43.9 S377.8,293.4,377.8,266.9z M444,266.9c0-10.4-6.4-21.8-21-21.8c-14.3,0-20.8,11.4-20.8,21.8c0,11.2,6,22.5,20.8,22.5 S444,278.7,444,266.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGambioGmbhLogoVector);
export default __webpack_public_path__ + "static/media/gambio-gmbh-logo-vector.eee4f62a26536519798f27a3341ed776.svg";
export { ForwardRef as ReactComponent };